{
  "version": 1,
  "asset_id": "62d94ce1-2c0e-4f6f-8cde-473ce526549a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/62d94ce1-2c0e-4f6f-8cde-473ce526549a/sleeve-ugi-normal-1145.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/62d94ce1-2c0e-4f6f-8cde-473ce526549a/sleeve-ugi-normal-1145.jpg",
  "original_filename": "sleeve-ugi-normal-1145.jpg",
  "size": 225211,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T01:31:04Z"
}
